const TABS = ['Paperwork', 'Eligibility']

const UI_STAFF_PROFILE_CONST = {
  TABS,
}

export default UI_STAFF_PROFILE_CONST
